export { default as Maintenance } from './Maintenance';
export { default as PhotoAdmin } from './PhotoAdmin';
export { default as News } from './News';
export { default as NewsDetails } from './NewsDetails';
export { default as NewsNew } from './NewsNew';
export { default as Settings } from './Settings';
